import { useMemo } from "react"
import { useCurrentDate } from "../providers/CurrentdateProvider"

const formatCountdown = (ms: number) => {
    const totalSeconds = Math.max(0, Math.ceil(ms / 1000))
    const minutos = Math.floor(totalSeconds / 60)
    const segundos = totalSeconds % 60

    return `${minutos.toString().padStart(2, "0")}:${segundos.toString().padStart(2, "0")}`
}

// Cuenta regresiva de `durationMs` a partir de `startDate`, sincronizada con la fecha del servidor
export const useCountdown = (startDate: Date | undefined, durationMs: number) => {
    const [now] = useCurrentDate()

    return useMemo(() => {
        const remainingMs = startDate ? startDate.getTime() + durationMs - now.getTime() : durationMs
        const clampedMs = Math.min(Math.max(0, remainingMs), durationMs)

        return { timeLeft: formatCountdown(clampedMs), remainingMs: clampedMs, isFinished: clampedMs <= 0 }
    }, [now, startDate?.getTime(), durationMs])
}
